import { useSetAtom } from 'jotai'
import { useEffect } from 'react'
import Tabs, { Tab } from 'src/common/ui-kit/Tabs/Tabs'
import {
  activeTabAtom,
  editOfferAtom,
} from 'src/pages/DiscoverPage/discover-store'
import { OffersManagementTab } from './types'

interface OfferTabsProps {
  tab: OffersManagementTab
}

const tabs: Tab[] = [
  {
    name: 'Swap',
    path: '/discover/all-offers?offerStatuses=PartiallyTaken,NotTaken',
  },
  {
    name: 'My offers',
    path: '/discover/my-offers?offerStatuses=PartiallyTaken,NotTaken',
  },
  {
    name: 'Private OTC',
    path: '/discover/private-offers?offerStatuses=PartiallyTaken,NotTaken',
  },
]

const OfferTabs: React.FC<OfferTabsProps> = ({ tab = 'all' }) => {
  const setActiveTab = useSetAtom(activeTabAtom)
  const setEditOffer = useSetAtom(editOfferAtom)

  useEffect(() => {
    setActiveTab(tab)
    setEditOffer({ offer: null, open: false })
  }, [setActiveTab, setEditOffer, tab])

  return <Tabs tabs={tabs} />
}

export default OfferTabs
